import CityPageTemplate from "../city-template/CityPageTemplate";
import { yumaConfig } from "./data";

export default function YumaPage() {
  return <CityPageTemplate config={yumaConfig} />;
}